// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-communication-column {
    font-weight: 700;
    margin-top: 0.78rem;
    margin-bottom: 0.72rem;
    min-width: 4rem;
    max-width: 8rem;
    overflow: hidden;
    text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/app/contact/contact-main/contact-list/contact-item/contact-item-info/contact-communications-list/ContactCommunicationList.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B","sourcesContent":[".contact-communication-column {\r\n    font-weight: 700;\r\n    margin-top: 0.78rem;\r\n    margin-bottom: 0.72rem;\r\n    min-width: 4rem;\r\n    max-width: 8rem;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
